module.exports = {"220284001":"福安街道","220284002":"东宁街道","220284003":"河南街道","220284070":"磐石经济开发区特殊街道","220284100":"烟筒山镇","220284101":"红旗岭镇","220284102":"明城镇","220284103":"石嘴镇","220284104":"驿马镇","220284105":"牛心镇","220284106":"呼兰镇","220284107":"吉昌镇","220284108":"松山镇","220284109":"黑石镇","220284110":"朝阳山镇","220284111":"富太镇","220284112":"取柴河镇","220284200":"宝山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220284.json
// module id = 717
// module chunks = 0